import { useQuery } from '@hooks/reactQuery';

import { getAlarmNodeTypes, getSeveritiesFlexidas } from '@api/common';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted, optionsFormattedByName } from '@utils/formatter';

import { IAlarmFilter } from '@interfaces/alarms/alarm';
import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { ALARM_NODE_TYPES, ALARM_SEVERITIES } from '@constants/queryKeys';
import {
	statusAlarmManagementStringOptions,
} from '@components/routes/AdminPanel/AlarmManagement/AlarmManagementByVendor/constants';

export const useQueryFlexidasAlarmFilters = (vendor: string) => {
	const isEnabled = vendor === EVendorsValues.limenet;

	const {
		data: nodeTypes,
		isInitialLoading: isLoadingNodeTypes,
	} = useQuery<Array<TNameTitle>, TSelectOptionType<string>[]>({
		queryKey: [ALARM_NODE_TYPES],
		queryFn: getAlarmNodeTypes,
		select: (names) => optionsFormattedByName(names),
		enabled: [isEnabled],
		...refetchOptions,
	});

	const {
		data: severities,
		isInitialLoading: isLoadingSeverities,
	} = useQuery<Array<TNameTitle>, TSelectOption<string>[]>({
		queryKey: [ALARM_SEVERITIES],
		queryFn: extractQueryParams(getSeveritiesFlexidas),
		select: (severities) => optionsFormatted<TNameTitle>(severities),
		enabled: [isEnabled],
		...refetchOptions,
	});

	const flexidasFilters: IAlarmFilter[] = isEnabled ? [
		{
			name: 'alarmNodeType',
			placeholder: 'Node type',
			data: nodeTypes || [],
		},
		{
			name: 'alarmSeverity',
			placeholder: 'Severities',
			data: severities || [],
		},
		{
			name: 'alarmMask',
			placeholder: 'Masked',
			data: statusAlarmManagementStringOptions,
		},
	] : [];

	return {
		filters: flexidasFilters,
		isLoading: isLoadingNodeTypes || isLoadingSeverities,
	};
};
